import { defaultColors } from "../../Services/contexts/ServicesChartsDataContext";
import { coresFigma } from "../../styles/colors";

export const usePyramidChart = ({ values, subtitles, colors }) => {
    const chartConfig = {
        series: [
            {
                name: 'Total',
                data: values || []
            }
        ],
        options: {
            chart: {
                type: 'bar',
                height: 200,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 0,
                    horizontal: true,
                    distributed: true,
                    isFunnel: true,
                }
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#333']
                }
            },
            xaxis: {
                categories: subtitles || []
            },
            yaxis: {
                labels: {
                    formatter: (val) => `${val.toLocaleString('pt-BR')}`
                }
            },

            colors: defaultColors,
            tooltip: {
                y: {
                    formatter: (val) => `${val.toLocaleString('pt-BR')}`
                }
            },
            grid: {
                show: false
            },
        }
    };

    return {
        chartConfig
    };
};
